import Divider from "../Divider";

export function SectionHeader({ heading }: { heading: string }) {
  return (
    <div className='flex items-center text-4xl/snug xs:text-5xl/snug md:text-6xl/snug'>
      <h3 className='font-medium'>{heading}</h3>
    </div>
  );
}
